import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Box, Image, Text, Flex } from 'atoms';
import closeCrossBlue from 'assets/close-cross-blue.svg';
import upiqr from 'utils/upi-qr-code';

const Container = styled.div`
	position: fixed;
	top: 40px;
	left: 0;
	right: 0;
	z-index: 10;
	max-width: 400px;
	width: 90%;
	margin: 0 auto;
	padding-bottom: 5rem;
	border-radius: 4px;
	background-color: ${(props) => props.theme.colors.white};
`;

const Header = styled.div`
	height: 45px;
	padding: 10px;
	border-radius: 4px;
	color: ${(props) => props.theme.colors.Jet};
`;

export const Body = styled.div`
	padding: 0 10px;
	color: ${(props) => props.theme.colors.Jet};
`;

export default function QRCodeModal({ onClose, upiData }) {
	const [QRCodeImg, setQRCodeImg] = useState(null);

	useEffect(() => {
		const companyName = 'Intelligent Retail Pvt Ltd';

		upiqr({
			payeeVPA: upiData,
			payeeName: companyName,
		})
			.then((upi) => {
				setQRCodeImg(upi.qr);
			})
			.catch((err) => {
				console.log('QR Code Error', err);
			});
	}, [upiData]);

	return (
		<Container>
			<Header position="relative">
				<Flex justifyContent="center">
					<Text fontSize="12px" pt="1rem">
						Scan to Pay
					</Text>
				</Flex>
				<Box cursor="pointer" onClick={onClose} position="absolute" top="20px" right="20px">
					<Image src={closeCrossBlue} alt="Close-Icon" height={16} width={16} />
				</Box>
			</Header>
			<Flex justifyContent="center" alignItems="center" mt="2rem" flexDirection="column">
				{QRCodeImg ? (
					<Image
						// src={`data:image/svg+xml;utf8,${QRCodeImg}`}
						src={QRCodeImg}
						alt="qrCode"
						height={240}
						width={240}
					/>
				) : (
					<Text
						fontSize="12px"
						fontWeight="600"
						pt="1rem"
						height="240px"
						lineHeight="240px"
					>
						Loading...
					</Text>
				)}
				<Text fontSize="12px" fontWeight="600" pt="1rem">
					{upiData}
				</Text>
			</Flex>
		</Container>
	);
}

QRCodeModal.propTypes = {
	onClose: PropTypes.func.isRequired,
	upiData: PropTypes.string.isRequired,
};
